// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"547":"a99db6a3","897":"820dc016"}[chunkId] + ".chunk.js";
};